import { Component, OnInit } from '@angular/core';
import { InfoBoxComponent } from '../../components/utility/info-box/info-box.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { Router, RouterModule } from '@angular/router';
import { NavigationMenuComponent } from '../../components/utility/navigation-menu/navigation-menu.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { DataService } from '../../services/data.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-personal-area',
    imports: [CommonModule, InfoBoxComponent, TranslateModule, NzMenuModule, RouterModule, NavigationMenuComponent, NavigationMenuComponent, NzDividerModule],
    templateUrl: './personal-area.component.html',
    styleUrls: ['./personal-area.component.scss']
})
export class PersonalAreaComponent implements OnInit {
  links: string[] = [];
  isNotDetails: boolean = true;

  constructor(
    private dataService: DataService,
    private router: Router
  ) {
    const currentUrl = this.router.url;
    if (currentUrl.includes('payment-details')) {
      this.isNotDetails = false;
    } else {
      this.isNotDetails = true;
    }
  }

  ngOnInit() {
    this.getCustomLinks();
  }

  public getCustomLinks(): string[] {
    this.dataService.getAccountDataFrom().subscribe((res) => {
      if (res) {
        this.links = ['your-data', 'invoices-and-methods-payment'];
      } else {
        this.links = ['your-data', 'profile-management', 'invoices-and-methods-payment'];
      }
    });
    return [];
  }
}
